import styled from 'styled-components'

const SurveyTextAreaWrapperUi = styled.div`
  position: relative;
`
export default SurveyTextAreaWrapperUi
